import React, { useState } from 'react'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../static/styles/global'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import moment from 'moment'
import Canvas from '../../canvas'
import CustomButton from '../../shared/button/Button'
import SignatureFormView from '../SignatureFormView'

const IlInformationOnline = ({ navigation, route }) => {
    const {
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
    } = route.params

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postilonline } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState(false);
    const [signatureDataURL, setSignatureDataURL] = useState('')


    const handlesubmit = async (signatureDataURL: any) => {

        const data = {
            completeOnline: true,
            essUserKey: intializeStore.initializeData?.userkey,
            entityId: personalstore.personalData?.entityId,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            sign: signatureDataURL,
            exempt: values?.exempt,
            basicAllowances: values?.basicallowances ? Number(values?.basicallowances) : null,
            additionalAllowances: values?.additionalallowances ? Number(values?.additionalallowances) : null,
            withheldFromEachPay: values?.withheldfromeachpay ? Number(values?.withheldfromeachpay) : null,
            maritalStatus: values?.martialstatus
        }
        const response = await postilonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'IL Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('IlInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
                stateValue='IL'
            />
        </>
    )
}

export default IlInformationOnline
